import React from 'react';
import PropTypes from 'prop-types';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import '../View.css';
import AccountVerificationService from '../../../service/AccountVerificationService';

class AVSWhitelist extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      customerId: '',
      status: '',
      isLoading: false,
    };
    this.INPUT_BOX_ID = 'view.customerId.text';
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (event) => {
    this.setState({
      customerId: event.target.value.trim(),
      status: '',
    });
  };

  handleSubmit = () => {
    const { customerId, } = this.state;
    if (customerId === '') {
      return;
    }
    this.setState({
      isLoading: true,
      status: '',
    });

    AccountVerificationService.addToWhitelist(customerId)
      .then((result) => {
        let until;
        if (result && result.data && result.data.whiteListExpirationTimestamp) {
          until = new Date(result.data.whiteListExpirationTimestamp * 1000);
        }
        this.setState({
          status: (
            <Alert dismissible className="mt-2" variant="success">
              <Alert.Heading>Success!</Alert.Heading>
              <p>{`Customer ${customerId} was successfully white listed${until ? ` until ${until}` : ''}.`}</p>
            </Alert>
          ),
        });
      })
      .catch(() => {
        this.setState({
          status: (
            <Alert dismissible className="mt-2" variant="danger">
              <Alert.Heading>Error</Alert.Heading>
              <p>{`Unable to white list ${customerId}`}</p>
            </Alert>
          ),
        });
      })
      .finally(() => {
        this.setState({ isLoading: false, });
      });
  };

  render() {
    const vm = this;
    const { onBack, } = this.props;
    const { username, status, isLoading, } = this.state;

    return (
      <div className="content mt-2" style={{ marginTop: '50px', }}>
        <span className="lead">Whitelist Ach Account Creation</span>
        <br />
        <span>
          If the Account Verification Feature is enabled then white listing the Customer ID will bypass this feature for 24 hours.
        </span>
        <br />
        {status}
        <br />
        <input
          id={vm.INPUT_BOX_ID}
          className="form-control"
          placeholder="customerId"
          value={username}
          onChange={this.handleChange}
        />
        <br />
        <Button
          variant="primary"
          onClick={this.handleSubmit}
          disabled={isLoading}
        >
          {isLoading ? '...loading' : 'Add'}
        </Button>
        <br />
        <br />
        <div className="pull-right">
          <Button variant="link" onClick={onBack}>
            ...back
          </Button>
        </div>
      </div>
    );
  }
}

AVSWhitelist.propTypes = {
  onBack: PropTypes.instanceOf(Function).isRequired,
};

export default AVSWhitelist;
